// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e2719bb","952":"9da3fcab"}[chunkId] + ".chunk.js";
};